"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trk = void 0;

var _ = require(".");

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

/**
 * trk is a short hand method for track event
 *
 * @deprecated
 * @param {string} event with format "category:action:label"
 * @param {*} withPageView
 * @param {*} context
 */
var trk = function trk(event, withPageView, context) {
  var defaultValue = window.trk_value ? window.trk_value : -1;
  var parts = event.split(':');
  var cat = parts.length > 0 ? parts[0] : null;
  var act = parts.length > 1 ? parts[1] : null;
  var lbl = parts.length > 2 ? parts[2] : null;
  var val = parts.length > 3 ? parts[3] : defaultValue; //console.log('track trk', cat, act, lbl, val, defaultValue, window.trk_value)

  if (withPageView && cat) {
    var url = "/#/fun/events/".concat(cat.replace(/\s/gi, ''));

    if (act) {
      url += "/".concat(act.replace(/\s/gi, ''));
    }

    if (lbl) {
      url += "/".concat(lbl.replace(/\s/gi, ''));
    }

    (0, _.trackPage)(url);
  }

  if (cat) {
    (0, _.trackEvent)({
      category: cat,
      action: act,
      label: lbl
    });
  }
};

exports.trk = trk;